import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FacialRecognitionService } from '@fgb/core';

@Component({
  selector: 'fgb-facial-recognition-upload-page',
  templateUrl: './facial-recognition-upload-page.component.html',
  styleUrl: './facial-recognition-upload-page.component.scss',
})
export class FacialRecognitionUploadPageComponent implements OnInit {
  uploadedImage: FormControl = new FormControl();
  formData: FormControl = new FormControl();
  isUploadInfo: boolean = false;
  goToStep: number;

  constructor(private facialRecognitionService: FacialRecognitionService) {}

  ngOnInit(): void {
    this.uploadedImage.setValue(this.facialRecognitionService.uploadedImage?.value);
    this.formData.setValue(this.facialRecognitionService.formData?.value);
    this.isUploadInfo = this.facialRecognitionService.isUploadInfo;
    this.goToStep = this.facialRecognitionService.goToStep;
  }
}
